module.exports = "pegasus_template/assets/email1-img10.png";